export default __webpack_public_path__ + "static/media/vision-choice-bw.518f7b7b.jpg";